import { luscinia } from "../luscinia";

class IntervalStage {
    Id: string;
    InvoiceIntervalId: string;
    StageInvoiceIntervalId: string;
    Duration: number;
}

class StagedIntervalConfigurator {
    container: HTMLDivElement;
    intervalStages: IntervalStage[] = [];

    constructor() {
        this.container = document.createElement("div");
        this.container.classList.add("staged-interval-configurator");
        this.container.style.display = "flex";
    }

    render() {
        const stagesContainer = document.createElement("div");
        stagesContainer.classList.add("interval-stages", "col-md-10", "col-sm-12", "col-xs-12");
        stagesContainer.id = "property-container"

        const addButton = document.createElement("button");
        addButton.classList.add("btn", "btn-success", "btn-sm");
        addButton.style.width = "30px";
        addButton.style.height = "30px";
        addButton.onclick = () => this.addStage();

        const icon = document.createElement("span");
        icon.classList.add("fa", "fa-plus");
        addButton.appendChild(icon);

        this.container.innerHTML = "";
        this.container.appendChild(stagesContainer);
        this.container.appendChild(addButton);

        if (this.intervalStages.length === 0) {
            this.addStage();
        } else {
            this.intervalStages.forEach((stage, index) => {
                stagesContainer.appendChild(this.renderStage(stage, index));
            });
        }

        return this.container;
    }

    renderStage(intervalStage: IntervalStage, index: number): HTMLDivElement {
        const stageContainer = document.createElement("div");
        stageContainer.classList.add("interval-stage");
        stageContainer.dataset.stageIndex = index.toString();
        stageContainer.style.display = "flex";
        stageContainer.style.marginBottom = "10px";

        stageContainer.appendChild(this.renderStageNumberEl(index));
        stageContainer.appendChild(this.renderInputsContainer(intervalStage, index));
        stageContainer.appendChild(this.renderRemoveButton(index));

        return stageContainer;
    }
    
    addStage(intervalStage?: IntervalStage): void {
        if (!intervalStage) {
            intervalStage = new IntervalStage();
            this.intervalStages.push(intervalStage);
        }
        this.render();
    }

    getCurrentStageCount(): number {
        return this.intervalStages.length;
    }

    private renderRemoveButton(index: number) {
        const removeButton = document.createElement("button");
        removeButton.classList.add("btn", "btn-danger", "btn-sm");
        removeButton.style.width = "30px";
        removeButton.style.height = "30px";
        removeButton.onclick = () => {
        this.intervalStages.splice(index, 1);
        this.render();
        };

        const icon = document.createElement("span");
        icon.classList.add("fa", "fa-trash");
        removeButton.appendChild(icon);

        return removeButton;
    }

    private renderIntervalSelectFormGroup(intervalStage: IntervalStage, index: number) {
        const intervalFormGroup = document.createElement("div");
        intervalFormGroup.classList.add("form-group", "form-group-sm");
        intervalFormGroup.style.display = "flex";
        intervalFormGroup.style.width = "100%";

        // Interval dropdown label
        const intervalLabel = document.createElement("label");
        intervalLabel.textContent = "Interval Type:";
        intervalLabel.htmlFor = "intervalSelect";
        intervalLabel.style.width = "70px";
        intervalLabel.style.flexShrink = "0";

        // Interval dropdown
        const intervalSelect = document.createElement("input");
        intervalSelect.value = intervalStage.StageInvoiceIntervalId || "00000000-0000-0000-0000-000000000000";
        intervalSelect.id = "intervalSelect";
        intervalSelect.name = `stage-${index.toString()}-intervalSelect`;
        intervalSelect.dataset.lusciniaAjaxSelectUrl = "/data/invoiceintervals/select2/non-staged-interval-select";
        intervalSelect.style.marginLeft = "10px";

        intervalFormGroup.appendChild(intervalLabel);
        intervalFormGroup.appendChild(intervalSelect);

        luscinia.initializeAjaxSelect2($(intervalSelect));
        $(intervalSelect).on("change", (e) => {
            const target = e.target as HTMLInputElement;
            this.intervalStages[index].StageInvoiceIntervalId = target.value;
        });

        return intervalFormGroup;
    }

    private renderDurationInputFromGroup(intervalStage: IntervalStage, index: number) {
        const durationFormGroup = document.createElement("div");
        durationFormGroup.classList.add("form-group");
        durationFormGroup.style.display = "flex";
        durationFormGroup.style.width = "100%";

        // Duration input label
        const durationLabel = document.createElement("label");
        durationLabel.textContent = "Duration:";
        durationLabel.htmlFor = "durationInput";
        durationLabel.style.width = "70px";

        // Duration input
        const durationInput = document.createElement("input");
        durationInput.value = intervalStage.Duration ? intervalStage.Duration.toString() : "0";
        durationInput.type = "number";
        durationInput.id = "durationInput";
        durationInput.name = `stage-${index.toString()}-durationInput`;
        durationInput.min = "0";
        durationInput.classList.add("duration-input", "form-control");
        durationInput.style.width = "50px";
        durationInput.style.marginLeft = "10px";
        durationInput.addEventListener("input", (e) => {
            const target = e.target as HTMLInputElement;
            this.intervalStages[index].Duration = parseInt(target.value);
        });

        durationInput.addEventListener("blur", (e) => {
            const target = e.target as HTMLInputElement;
            if (target.value === "") {
                target.value = "0";
                this.intervalStages[index].Duration = 0;
            }
        });

        durationFormGroup.appendChild(durationLabel);
        durationFormGroup.appendChild(durationInput);
        return durationFormGroup;
    }

    private renderStageNumberEl(index: number) {
        const stageNumberEl = document.createElement("span");
        stageNumberEl.textContent = `${(index + 1).toString()} - `;
        stageNumberEl.style.marginRight = "10px";
        stageNumberEl.style.whiteSpace = "nowrap";
        return stageNumberEl;
    }

    private renderInputsContainer(intervalStage: IntervalStage, index: number) {
        const inputsContainer = document.createElement("div");
        inputsContainer.style.display = "flex";
        inputsContainer.style.flexDirection = "column";
        inputsContainer.style.width = "100%";
        inputsContainer.style.paddingLeft = "10px";

        inputsContainer.appendChild(this.renderIntervalSelectFormGroup(intervalStage, index));
        inputsContainer.appendChild(this.renderDurationInputFromGroup(intervalStage, index));

        return inputsContainer;
    }
}

luscinia.renderStagedIntervalConfiguration = async function () {
    const form = document.querySelector('form[data-luscinia-modulepath="/data/invoiceintervals"]') as HTMLFormElement;

    if (!form) {
        return;
    }

    (form.querySelector('.form-group:has(input[name="Quantity"]') as HTMLElement).style.display = "none";
    (form.querySelector('.form-group:has(select[name="IntervalType"]') as HTMLElement).style.display = "none";

    const currentConfigurator = form.querySelector(".staged-interval-configurator") as HTMLElement;
    if (currentConfigurator) {
        currentConfigurator.style.display = "block";
        return;
    }

    let stages: IntervalStage[] = [];
    const invoiceIntervalId = (form.querySelector('input[name="Id"]') as HTMLInputElement).value;
    if (invoiceIntervalId !== "00000000-0000-0000-0000-000000000000") {
        stages = await (await fetch(`/data/invoiceintervals/stages/${invoiceIntervalId}`)).json();
    }

    const inputContainer = document.createElement("div");
    inputContainer.classList.add("staged-interval-configurator", "form-group", "form-group-sm");

    const label = document.createElement("label");
    label.classList.add("col-md-2", "col-sm-12", "col-xs-12", "control-label");
    label.textContent = "Stages";

    const stagedIntervalConfigurator = new StagedIntervalConfigurator();
    stagedIntervalConfigurator.intervalStages = stages;
    const stagedIntervalConfiguratorElement = stagedIntervalConfigurator.render();

    inputContainer.appendChild(label);
    inputContainer.appendChild(stagedIntervalConfiguratorElement);

    const isStagedCheckbox = form.querySelector('.form-group:has(input[name="Name"])') as HTMLInputElement;
    isStagedCheckbox.insertAdjacentElement("afterend", inputContainer);
};

luscinia.renderNonStagedIntervalConfiguration = function () {
    const form = document.querySelector('form[data-luscinia-modulepath="/data/invoiceintervals"]') as HTMLFormElement;

    if (!form) {
        return;
    }

    (form.querySelector('.form-group:has(input[name="Quantity"]') as HTMLElement).style.display = "block";
    (form.querySelector('.form-group:has(select[name="IntervalType"]') as HTMLElement).style.display = "block";

    const currentConfigurator = form.querySelector(".staged-interval-configurator") as HTMLElement;
    if (currentConfigurator) {
        currentConfigurator.style.display = "none";
    }
};
